import { createUseStyles } from "react-jss";
import { ITheme } from "../../../store/slices/theme";

export const useStyles = createUseStyles((theme: ITheme) => ({
  root: {
    padding: `${theme.spacing.space20}px ${theme.spacing.space16}px`,
    background: "rgba(0, 0, 0, 0.5)",
    borderRadius: theme.radius.small,
  },
  wallets: {
    justifyContent: "initial",
    marginTop: theme.spacing.space12,
  },
}));
